'use client';

import { Suspense as RouteSuspense } from 'react';
import { PageLoading as RouteLoading } from '@/app/Components/LoadingBubbles';
import { useSearchParams } from 'next/navigation';
import AssistantButton from '@/app/Components/Assistant/AssistantButton';
import { RouteStateFixture } from '@/app/Components/RouteStateFixture';
import { auditFixtureState } from '@/app/lib/routeStateContract';
import { ResearchOpportunitiesDirectoryView } from './ResearchOpportunitiesDirectoryView';
import { useResearchOpportunitiesController } from './useResearchOpportunitiesController';

function ResearchOpportunitiesRoute() {
  const searchParams = useSearchParams();
  const fixtureState = auditFixtureState(searchParams.get('auditFixture'));
  if (fixtureState) {
    return <RouteStateFixture route="research-opportunities" state={fixtureState} />;
  }
  return <ResearchOpportunitiesPage tag={searchParams.get('tag')} />;
}

function ResearchOpportunitiesPage({ tag }: { tag: string | null }) {
  const controller = useResearchOpportunitiesController(tag);
  const { filters, selected } = controller.model;
  return (
    <>
      <ResearchOpportunitiesDirectoryView model={controller.model} actions={controller} />
      <AssistantButton
        context={{
          skill: 'research_opportunities',
          searchQuery: filters.searchQuery,
          selectedSource: filters.sourceTab,
          paidOnly: Boolean(filters.paidOnly),
          creditOnly: Boolean(filters.creditOnly),
          selectedDepartment: filters.department,
          selectedProgramType: filters.programType,
          selectedCampus: filters.campus,
          selectedSubject: filters.subject,
          includeNSF: filters.includeNSF,
          includeREU: filters.includeREU,
          selectedProjectTitle: selected?.title,
          selectedProfessor: selected?.professor,
        }}
      />
    </>
  );
}

// Query-dependent interactive content owns its loading boundary.
export default function RoutePage() { return <RouteSuspense fallback={<RouteLoading title="Preparing your workspace" />}><ResearchOpportunitiesRoute /></RouteSuspense>; }
